import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';
import styled from '../../_snowpack/pkg/styled-components.js';
import { colors } from './colors.js';
const colorsMap = {
  green: colors.glacier,
  grey: colors.grey,
  red: colors.defrost,
  yellow: colors.yellow
};
const StyledChip = styled.span.withConfig({
  displayName: "chip__StyledChip",
  componentId: "sc-14q7v5h-0"
})(["background:", ";height:", "px;width:", "px;border-radius:", "px;color:", ";font-size:", "px;font-weight:500;line-height:1;padding:", ";text-transform:", ";white-space:nowrap;display:flex;align-items:center;"], ({
  color
}) => {
  const standardColor = colorsMap[color];

  if (!standardColor) {
    return color;
  }

  return standardColor;
}, props => props.height, props => props.width, props => props.height / 2, props => props.textColor, props => props.size, props => props.hasButton ? '0.5rem 0.5rem 0.5rem 1rem' : '0.5rem 0.5rem', props => props.transform); // TODO - Make it as a button

const RemoveButton = styled.button.withConfig({
  displayName: "chip__RemoveButton",
  componentId: "sc-14q7v5h-1"
})(["background:transparent;border:none;cursor:pointer;margin-left:20px;margin-right:10px;padding:0;font-weight:300;:hover{opacity:0.5;}color:", ";font-size:", "px;"], props => props.color, props => props.size + 5);

const Chip = ({
  children,
  color,
  onRemove,
  text,
  height,
  width
}) => {
  return /*#__PURE__*/React.createElement(StyledChip, {
    height: height,
    width: width,
    transform: text.transform,
    hasButton: !!onRemove,
    color: color,
    textColor: text.color,
    size: text.size
  }, children, onRemove && /*#__PURE__*/React.createElement(RemoveButton, {
    color: text.color,
    size: text.size,
    onClick: onRemove
  }, "X"));
};

Chip.propTypes = {
  onRemove: PropTypes.func,
  color: PropTypes.string,
  text: PropTypes.shape({
    color: PropTypes.string,
    size: PropTypes.number,
    transform: PropTypes.string
  }),
  height: PropTypes.number
};
Chip.defaultProps = {
  color: 'grey',
  textColor: 'white',
  height: 30,
  text: {
    color: 'white',
    size: 13,
    transform: 'uppercase'
  }
};
export { Chip };